type RemoveCookie = (name: string, options?: { path?: string; domain?: string }) => void;

export function removeAuthCookies(
	cookieNames: Iterable<string>,
	removeCookie: RemoveCookie,
	cookieDomains: Iterable<string | undefined>,
) {
	const domains = new Set([...cookieDomains].filter((domain): domain is string => Boolean(domain)));

	for (const cookieName of cookieNames) {
		for (const domain of domains) {
			removeCookie(cookieName, { path: '/', domain });
		}
		removeCookie(cookieName, { path: '/' });
	}
}
